import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Adv2Config } from '../interfaces/iadv2config';

@Injectable({ providedIn: 'root' })
export class Adv2ConfigService {
  constructor(private http: HttpClient) {}

  getConfig(): Observable<Adv2Config> {
    const url = `${environment.kpHost}/adv2/config`;
    return this.http.get<Adv2Config>(url);
  }

  testSignatureCredentials(signatureConfig: any): Observable<any> {
    const url = `${environment.kpHost}/adv2/config/testSignatureCredentials`;
    return this.http.post(url, signatureConfig);
  }

  getConsentUrl(consentDetails: any): Observable<any> {
    const url = `${environment.kpHost}/adv2/config/signatureconsent`;
    return this.http.post(url, consentDetails);
  }
}
